import localeEs from './localeEs';
import localeEn from './localeEn';
import localeFr from './localeFr';
import localePt from './localePt';
import localeIt from './localeIt';


const messages = {
  es: localeEs,
  en: localeEn,
  fr: localeFr,
  pt: localePt,
  it: localeIt,
};


export default messages;
